<template>
  <transition name="fade"
              appear>
    <div class="app_dialog" :class="{ dimmed, fixed }">
      <div class="dialog_content" :style="contentStyle">
        <i v-if="close" class="icon icon--close-size16" @click="onCloseClick(noValue)"></i>
        <span v-if="dialogData.iconClass" class="icon" :class="dialogData.iconClass"/>
        <p class="title" :class="dialogData.titleClass" v-if="dialogData.title" v-html="dialogData.title"></p>
        <p class="description" v-if="dialogData.description" v-html="dialogData.description"></p>
        <p class="description" v-if="!dialogData.description && optionMsg" v-html="optionMsg"></p>
        <div v-if="optionContent" :style="optionContent.style" v-html="optionContent.text"></div>
        <div v-if="mashupDate" class="content">
          <ul>
            <li>
              <span class="content_title"> {{ $t('dialog.report.duplicateMashup.time')}} : </span>
              <span class="content">{{ mashupDate }}</span>
            </li>
          </ul>
        </div>
        <p class="action">
          <template v-if="dialogData.type === 'confirm'">
            <ui-button @click="onCloseClick(noValue)">{{ cancel }}</ui-button>
            <ui-button primary2 @click="onCloseClick(yesValue)">{{ yes }}</ui-button>
          </template>
          <template v-else-if="dialogData.type === 'alert'">
            <ui-button @click="onCloseClick">{{ ok }}</ui-button>
          </template>
          <template v-else-if="dialogData.type === 'mashup'">
            <ui-button primary2 @click="onCloseClick('report')" :iconName="'icon--check-red-size16'">{{ $t('common.nowCheck') }}</ui-button>
          </template>
          <template v-else-if="dialogData.type === 'pvEmpty'">
            <i class="icon icon--close14" @click="onCloseClick(noValue)"></i>
            <ui-button primary2 @click="onCloseClick(yesValue)">{{ $t('common.upgradePlan') }}</ui-button>
            <ui-button primary4 @click="onCloseClick('pv')" :iconName="'icon--pv-plug'"
                       :disabled="$i18n.locale === 'ja'">{{ $t('common.chargePv') }}</ui-button>
          </template>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
import getDialogData from '@/data/dialog-data'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'AppDialog',
  components: {
    UiButton
  },
  props: {
    optionMsg: {
      type: String
    },
    dialogType: {
      type: String,
      required: false
    },
    optionContent: {
      type: Object,
      required: false
    },
    customData: {
      type: Object,
      required: false
    },
    yes: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    no: {
      type: String,
      default () {
        return this.$t('common.no')
      }
    },
    ok: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    cancel: {
      type: String,
      default () {
        return this.$t('common.cancel')
      }
    },
    yesValue: {
      default: true
    },
    noValue: {
      default: false
    },
    dimmed: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: Object,
      required: false
    },
    mashupDate: {
      type: String,
      required: false,
      default: null
    },
    close: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rawData: null
    }
  },
  computed: {
    dialogData () {
      if (this.customData) {
        return this.customData
      }

      const paths = this.dialogType.split('.')
      let data = this.rawData

      for (const path of paths) {
        if (!data[path]) {
          throw new Error(`invalid dialogType: ${this.dialogType}`)
        } else {
          data = data[path]
        }
      }
      return data
    }
  },
  created () {
    this.rawData = getDialogData(this.$i18n)

    if (document.activeElement) {
      document.activeElement.blur()
    }
  },
  methods: {
    onCloseClick (value) {
      if (this.$close) {
        // called by vue-modal-dialogs
        this.$close(value)
      } else {
        // called by normal component
        this.$emit('onCloseClick', value)
      }
      if (this.arguments[0].result) {
        this.arguments[0].result(value)
      }
    }
  }
}
</script>

<style lang="scss">
.app_dialog {
  pointer-events: none;
  transition: opacity 0.3s ease;
  .icon--close-size16 {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  &.fade-enter-active,
  &.fade-leave-active {
    opacity: 1;
    transition: opacity 0.15s ease;
  }
  &.fade-enter,
  &.fade-leave-to{
    opacity: 0;
  }

  .icon--close14{
    position: absolute;
    top: 12px;
    right: 12px;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
  }

  .dialog_content {
    pointer-events: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    box-sizing: border-box;
    padding: 50px 40px 37px 40px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    text-align: center;
    div.content {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.62;
      letter-spacing: normal;
      color: #767676;

      border: solid 1px #d7d7d7;
      border-radius: 5px;
      background-color: #f4f4f4;
      padding: 20px 0px 15px 0px;
      margin-bottom: 40px;

      li {
        margin-bottom: 5px;
        font-size: 14px;
        text-align: left;
        padding-left: 20px;
        span.content_title {
          display: inline-block;
          width: 86px;
          vertical-align: top;
        }

        span.content {
          color: #444;
          max-width: 370px;
          display: inline-block;
          padding-right: 5px;
          word-wrap: break-word;
        }
      }
    }
    .icon {
      margin-bottom: 13px;
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: #444;
      margin-bottom: 10px;
      line-height: 1.2;

      &.warning {
        color: $brandColor;
      }
    }

    .description {
      font-size: 14px;
      color: #2f2f2f;
      margin-bottom: 28px;
      line-height: 1.43;
      white-space: pre-line;
      // word-break: break-all;
      &:lang(ja) {
        font-size: 13px;
      }

      .highlight {
        color: $brandColor;
      }

      ul {
        display: inline-block;
        text-align: left;

        li {
          position: relative;
          margin: 10px 0 10px 10px;

          &::before {
            position: absolute;
            top: -1px;
            left: -10px;
            content: "-";
            color: #2f2f2f;
          }
        }
      }
    }

    .action {
      button {
        margin: 0 3px;
      }
    }
  }
}
</style>
